'use strict';

$(document).ready(function () {
  initFaqEvent();
});

function initFaqEvent() {
  $('.page-help-container #subject').on('change', function(e) {
    var $element = $(e.currentTarget);
    var url = $element.data('url');
    var cid = $element.find('option:selected').data('cid');
    var faqArticlesElement = $element.parent().siblings('#faq-articles');

    if (url && faqArticlesElement) {
      if (!cid) {
        faqArticlesElement.html('');
      } else {
        $.ajax({
          type: 'GET',
          url: url + '?cid=' + cid,
          success: (data) => {
            faqArticlesElement.html(data);
          },
          error: () => {
            faqArticlesElement.html();
          }
        });
      }
    }
  });
}

module.exports = {
  initFaqEvent: initFaqEvent
}